import React from 'react';
import { Box } from '@material-ui/core';
import { CONTENT_MAX_WIDTH, CONTENT_MIN_WIDTH, useLayoutStyles } from '../utilities/layouts/Globals';
import { COLOR_WHITE } from '../utilities/Material';
import clsx from 'clsx';
import { LoginStyle } from '../../styles/LoginStyle';
import { LoginImageLeft } from '../utilities/SvgIcons';

const LoginLayout = ({ children }) => {
    const classes = LoginStyle();
    const styles = useLayoutStyles();

    return (
        <Box height="100vh" display="flex" justifyContent="center" alignItems="center" style={{ backgroundColor: COLOR_WHITE }}>
            <Box className={clsx(styles.contentPadding, classes.container)} minWidth={CONTENT_MIN_WIDTH} width={CONTENT_MAX_WIDTH}>
                <Box className={classes.loginImageLeft}>
                    {LoginImageLeft && <img src={LoginImageLeft} alt="Login Left" />}
                </Box>
                <Box display="flex" flexDirection="column" className={classes.nonFillFormWidth}>
                    <div className={classes.invisibleFlexItemForCenter}></div>
                    {children}
                </Box>
            </Box>
        </Box>
    );
}

export default LoginLayout;